import { ContentBlock } from "@/types";
import { createSecurityServiceContent } from "@/content/services/service-content-helpers";

export const content: ContentBlock[] = [
  ...createSecurityServiceContent({
    serviceName: "intercom systems",
    summary:
      "Intercom systems help control who gets through the front door, gate or shared entry. Ozy Wide Group plans the visitor flow, device position and release method so occupants can identify visitors and manage access without leaving the secure area.",
    suitedTo: [
      "homes",
      "duplexes",
      "offices",
      "warehouses",
      "gated entries",
      "shared access points",
    ],
    includes: [
      "video intercoms",
      "audio intercoms",
      "door station installation",
      "internal monitors",
      "electric strike or gate-release coordination",
    ],
    notes: [
      "entry location",
      "screen position",
      "gate or door hardware",
      "network or cable path",
      "weather exposure",
      "who needs access",
    ],
    process: [
      "Check the entry point, mounting height, power and cable path before selecting the intercom setup.",
      "Install and connect the intercom hardware with the agreed release or call flow.",
      "Test visitor calls, audio/video clarity and release operation with the users who will rely on it.",
    ],
    faq: [
      "Video intercoms are helpful where visitors, deliveries or trades need to be visually confirmed.",
      "Gate and door release depends on the existing hardware and may need compatible locking equipment.",
      "Some intercom systems can support mobile app answering where network conditions allow it.",
    ],
  }),
];
